<template>
  <v-card :color="'rgb(250, 250, 250)'" class="elevation-0">
    <v-toolbar dense :color="colorBarraFormulario" dark flat>
      <v-toolbar-title v-bind:style="{ color: colorFondo300 }">
        <h5 v-bind:style="{ color: 'white' }">FICHA DEL MENSAJE</h5>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-icon size="30" :color="'white'" @click="_cerrarVentana"
        >mdi-close-circle</v-icon
      >
    </v-toolbar>
    <v-card-text>
      <v-row class="mt-8" dense>
        <v-col class="ml-0">
          <v-row dense class="mx-4">
            <v-text-field
              v-model="modelMensaje.titulo"
              outlined
              label="Título"
              dense
              :dark="dark"
              autocomplete="off"
            ></v-text-field>
          </v-row>

          <v-row dense class="mx-4">
            <v-text-field
              v-model="modelMensaje.asunto"
              outlined
              label="Asunto"
              dense
              :dark="dark"
              autocomplete="off"
            ></v-text-field>
          </v-row>

          <v-row dense class="mx-4">
              <v-textarea
              v-model="modelMensaje.texto"
              outlined
              label="Texto"
              dense
              :dark="dark"
              rows="12"
              autocomplete="off"
            ></v-textarea>
          </v-row>

          
        </v-col>
      </v-row>

      <v-row class="mx-4 mb-2">
        <v-spacer></v-spacer>
        <v-chip
          class="mr-1 px-10"
          label
          :color="colorEBikeAccent1"
          text-color="white"
          link
          @click="_guardarMensaje"
        >
          <h5 v-if="loading" v-bind:style="{ color: 'white' }">
                Guardando...
              </h5>
              <h5 v-else v-bind:style="{ color: 'white' }">Guardar</h5>
        </v-chip>
      </v-row>
    </v-card-text>
  </v-card>
</template>


<script>
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  name: "MensajeFormulario",
  components: {},
  data: () => ({
    loading: false,
    
  }),

  props: {
    modelMensaje: {
      type: Object,
      required: true,
    },

    accion: {
      type: String,
      required: true,
    }
  },

  computed: {
    ...mapState([
      "drawer",
      "dark",


      "colorEBikeAccent1",

      "colorFondo500",
      "colorFondo400",
      "colorFondo300",
      "colorFondo200",
      "colorFondo100",

      "colorFront500",
      "colorFront400",
      "colorFront300",
      "colorFront200",
      "colorFront100",

      "colorAccent2",
      "colorAccent1",
      "colorBarraFormulario",
    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),
  },

  

  mounted() {
  
  },

  methods: {
    ...mapActions("mensajes", ["getMensajes", "crearMensaje", "updateMensaje"]),

    

    

   

    _cerrarVentana() {
      this.$emit("cerrarFormularioMensaje");
    },

    async _guardarMensaje() {
      this.loading = true;
      if (this.accion == "crear") {
       
        var res = await this.crearMensaje([
          this.access_token,
          this.modelMensaje,
        ]);
        const params = {};
        this._cerrarVentana();
        await this.getMensajes([this.access_token, params, true]);
        
      } else if (this.accion == "editar") {
       
        var res = await this.updateMensaje([
          this.access_token,
          this.modelMensaje,
        ]);
        this._cerrarVentana();
      }
      this.loading = false;
    },
  },
};
</script>